import { useTranslation } from "react-i18next";
import { LegalPage } from "@/components/LegalPage";

export default function Terms() {
  const { t } = useTranslation();
  const sections = [
    [t("agreement.sectionRisk"), t("agreement.riskBody")],
    [t("agreement.sectionNotAdvice"), t("agreement.notAdviceBody")],
    [t("agreement.sectionNoRefund"), `${t("agreement.noRefundBody")} ${t("agreement.referralClauseBody")}`],
    [t("agreement.sectionLiability"), t("agreement.liabilityBody")],
    [t("legalPages.useTitle"), t("legalPages.useBody")],
    [t("legalPages.changesTitle"), t("legalPages.changesBody")],
  ];
  return <LegalPage testId="terms-page" title={t("legalPages.termsTitle")} intro={t("legalPages.termsIntro")} sections={sections} />;
}
